import uuid from 'uuid'
import * as helpers from '../../helpers/index.js'

// Set up kinto
import Kintodb from "../kintodb.js";

var kintooptions = {
	remote: "https://keepya-kinto-instance.herokuapp.com/v1",
	bucket: "keepya",
	credentials: {
		username: "user",
		password: "pass"
	},
	collections: ['elements', 'element_types', 'spaces'],
	pusher: {
		pusher_key: '507ee184bb245d27c59a'
	}
}

const kintodb = new Kintodb(kintooptions);
kintodb.init();

var elementSync = _.debounce(function(store){
	console.log("syncing elements debounced");
	store.dispatch("sync", "elements");
}, 500)

var spacesSync = _.debounce(function(store){
	console.log("syncing spaces debounced");
	store.dispatch("sync", "spaces");
}, 500)


// Element Actions

export const addNewElement = (store, el) => {
	console.log("ACTION new element", el);
	const model = _.find(store.state.elementTypes.data, {
		id: el.id
	});
	const elementModel = JSON.parse( JSON.stringify( model ) );
	return new Promise((resolve, reject) => {
		const newElement = {
			id: uuid.v1(),
			// listview: {
			// 	rows: []
			// },
			// inputform: {
			// 	areas: []
			// },
			atoms: elementModel.atoms,
			//name: elementModel.name,
			//type: elementModel.type,
			ref: elementModel.id,
			//icon: elementModel.icon,
			isCurrent: false,
			opened: false,
			parent: store.state.currentParent,
			space: store.state.currentSpace.id,
			children: [],
			type: elementModel.name
		};
		// _.forEach(elementModel.inputform.areas, function(area, ri) {
		// 	newElement.inputform.areas[ri] = {}
		// 	newElement.inputform.areas[ri].atoms = [];
		// 	_.forEach(area.atoms, function(atom, ai) {
		// 		newElement.inputform.areas[ri].atoms[ai] = {
		// 			id: atom.id,
		// 			component: atom.component
		// 		}
		// 	});
		// });
		store.commit('NEW_ELEMENT', newElement);
		resolve();
	}).catch(function(err) {
		console.log("ACTION NEW ELEMENT error catch");
		reject(err);
	});
}
export const updateElement = (store, el) => {
	store.commit("UPDATE_ELEMENT",el);
}
export const editElement = (store, el) => {
	console.log("ACTION edit element", el);
	const elementModel = _.find(store.state.elementTypes.data, {
		id: el.id
	});
	return new Promise((resolve, reject) => {
		const elementToEdit = el;
		store.commit('NEW_ELEMENT', elementToEdit);
		resolve();
	}).catch(function(err) {
		console.log("ACTION EDIT ELEMENT error catch");
		reject(err);
	});
}

export const cancelEdit = ({ commit }) => {
	return new Promise((resolve, reject) => {
		commit('RESET_NEW_ELEMENT_TYPE');
		resolve();
	}).catch(function(err) {
		console.log("error while cancel edit", err);
		reject(error);
	});
}

export const saveElementToDB = (store, updatedElement) => {
	let _this = this;
	return new Promise((resolve, reject) => {
		kintodb.elements.upsert(updatedElement).then(response => {
			// new element
			if (response.data._status === "created") {
				store.commit("ADD_ELEMENT", response.data);
				// check if space root element
				if (response.data.parent === response.data.space) {
					console.log("we have a space root element");
					let updatedSpace = store.state.currentSpace;
					updatedSpace.children.push(response.data.id);
					store.commit("SET_SPACE", updatedSpace);
					store.dispatch("saveSpaceToDB", updatedSpace).catch(function(err) {
						console.error("ACTION saveElementToDB: error while saving space", err);
					})
				}
			}

			if (response.data._status === "updated") {
				store.commit("UPDATE_ELEMENT", response.data);
			}

			// Try to sync not too often
			elementSync(store);

			console.log("upserted element", response);
			resolve(response);
		}, error => {
			reject(error)
		})
	})
}

export const deleteElement = (store, id) => {
	return new Promise((resolve, reject) => {
		console.log("ACTION: delete Element promise", id);
		kintodb.elements.delete(id)
			.then(function(response) {
				console.log("ACTION delete element:", response);
				store.commit("DELETE_ELEMENT", id);
				// change in current space?
				if (response.data.parent === store.state.currentSpace.id) {
					let updatedSpace = store.state.currentSpace;
					console.log("updatedSpace vorher", updatedSpace);
					updatedSpace.children.splice(_.findIndex(updatedSpace.children, {
						id: id
					}), 1);
					console.log("updatedSpace hinterher", updatedSpace);
					store.dispatch("saveSpaceToDB", updatedSpace).then((response) => {
						store.commit("SET_SPACE", updatedSpace);
						elementSync(store);
						spacesSync(store);
					})
				} 
				// change in elements parent
				else {
					const parentElement = store.state.elements.data[_.findIndex(store.state.elements.data, {
						id: response.data.parent
					})];
					parentElement.children.splice(_.findIndex(parentElement.children, {
						id: id
					}), 1);
					store.dispatch("saveElementToDB", parentElement);
				}
				resolve();
			}).catch(function(err) {
				console.error("error while deleting", err)
				reject(error);
			})
	});
}

export const resetNewElement = (store) => store.commit("RESET_NEW_ELEMENT")

// Space Actions

export const saveSpaceToDB = (store, space) => {
	if (!space.id) {
		// create new space
		var newspace = {
			id: uuid.v1(),
			name: space.name,
			children: [],
			created: Date.now(),
			type: 'space'
		};
	} else {
		newspace = space;
	}
	console.log("ACTION: setting new space", newspace);

	return new Promise((resolve, reject) => {
		kintodb.spaces.upsert(newspace).then(response => {
			if (response.data._status === "created") {
				let updatedSpaces = store.state.spaces;
				updatedSpaces.data.push(response.data);
				console.log("UpdatedSpaces", updatedSpaces)
				store.commit("SET_SPACES", updatedSpaces);
			}
			if (response.data._status === "updated") {
				store.dispatch("getListFromLocal", "spaces");
			}
			spacesSync(store);
			resolve(response);
		}, error => {
			reject(error)
		})
	})
}

export const setCurrentSpace = (store, space) => {
	if (space.value != 0 || space.id) {
		console.log("FUCKING SETCURRENT ACTION space", space)
		return new Promise((resolve, reject) => {
			kintodb.spaces.get(space.value).then(function(response) {
				console.log("ACTION getCurrentSpace – got space data:", response);
				store.commit("SET_SPACE", response.data);
			}).catch(function(err) {
				console.error("ACTION getCurrentSpace – error while selecting space", err)
				reject(err);
			})
		})
	} else {
		console.log("space no value");
		store.commit("SET_SPACE", false);
		//return store.dispatch('getListFromLocal', 'elements');
	}
}

export const deleteSpace = (store, id) => {
	return new Promise((resolve, reject) => {
		console.log("ACTION: delete Space promise");
		kintodb.spaces.delete(id).then(function(res) {
			store.commit("DELETE_SPACE", id);
			store.dispatch("sync", "spaces");
			resolve();
		}).catch(function(err) {
			console.error("error while deleting space", err)
			reject(error);
		})
	});
}

// Element Types and Builder Actions

export const addNewElementType = ({
	commit
}, id) => {
	return new Promise((resolve, reject) => {
		if (!id) {
			console.log("new el");
			const newElementType = {
				id: uuid.v1(),
				name: "",
				abbr: "",
				icon: "",
				category: "",
				type: "elementtype",
				atoms: {},
				inputform:
				{
					areas: [{
						id: 1,
						settings: {},
						atoms: []
					}],
					settings: {}
				},
				listview: {
					mixed: {
						displayLeft: {
							settings: {},
							atoms: []
						},
						displayRight: {
							settings: {},
							atoms: []
						},
						widgets: {
							settings: {},
							atoms: []
						},
						actions: {
							settings: {},
							atoms: []
						},
						settings: {}
					},
					table: {
						columns:[]
					}
				}
			}
			commit('NEW_ELEMENT_TYPE', newElementType)
			resolve();
		} else {
			kintodb.element_types.get(id).then(function(doc) {
				const newElementType = doc.data;
				commit('NEW_ELEMENT_TYPE', newElementType)
				resolve();
			}).catch(function(err) {
				console.error("havent found this element type", err)
				reject(err);
			})
		}
	})
}

export const addAtom = ({
	commit 
}) => {
	console.log("add action", commit);
	commit('ADD_ATOM')
}

export const setCurrentAtom = ({
	commit 
}, atom) => {
	console.log("set current", commit);
	commit('SET_CURRENT_ATOM', atom)
}

export const setCurrentElement = ({
	commit 
}, element) => {
	console.log("set current element", commit);
	commit('SET_CURRENT_ELEMENT', element)
}

export const removeAtom = ({
	commit 
}, areaindex, atomindex) => {
	commit('REMOVE_ATOM', areaindex, atomindex)
}

export const sortAtoms = ({
	commit 
}, areas) => {
	console.log("sort action", commit, areas);
	commit('SORT_ATOMS', areas)
}

export const addArea = ({
	commit
}) => commit('ADD_AREA')

export const saveElementTypeToDB = (store, updatedElement) => {
	return new Promise((resolve, reject) => {
		kintodb.element_types.upsert(updatedElement).then(doc => {
			store.dispatch("sync", "element_types");
			resolve(doc);
		}, error => {
			reject(error)
		})
	})
}

export const resetNewElementType = ({ commit }) => commit("RESET_NEW_ELEMENT_TYPE")

// Common Actions

export const sync = (store, collection) => {
	return new Promise((resolve, reject) => {
		kintodb[collection].sync().then((response) => {
			console.log("ACTION we synced " + collection, response.ok, response, response.conflicts.length, helpers);
			if (response.ok === false) {
				console.warn("Sync: We have a conflict ", helpers.compare(response.conflicts[0].local,response.conflicts[0].remote));
				// If conflicts, take local version and sync again.
				console.log("Prepare conflict solving...");
				return Promise.all(response.conflicts.map(conflict => {
					return kintodb[collection].resolve(conflict, conflict.local);
				})).then(_ => sync());
			} else {
				resolve(response);
			}
		}).catch(function(err) {
			if (!err.response && err.message) {
				// we are offline, no need to throw Error, but let's show it later in Status icon
				return resolve(err.message);
			}
			console.log("error while syncing docs", err);
			reject(err);
		});
	})
}

export const getListFromLocal = ({commit}, collection) => {
	const mutationName = "SET_" + collection.toUpperCase();
	return new Promise((resolve, reject) => {
		console.log("ACTION: getListFromLocal promise for ", collection);
		kintodb[collection].list({
				order: "created"
			})
			.then(function(data) {
				console.log("ACTION we listed " + collection, data)
				commit(mutationName, data);
				resolve();
			}).catch(function(err) {
				console.log("error while getting docs", err);
				reject(error);
			});
	});
}

export const deleteItem = ({ commit }, identifier) => {
	return new Promise((resolve, reject) => {
		console.log("ACTION: delete Element Type promise", identifier);
		kintodb[identifier.collection].delete(identifier.id)
			.then(function(data) {
				console.log("ACTION delete el type:", data);
				commit(identifier.mutation, identifier.id);
				resolve();
			}).catch(function(err) {
				console.error("error while deleting", err)
				reject(error);
			})
	});
}


// WEBPACK FOOTER //
// ./src/store/vuex/actions.js